import React, { useEffect, useState } from 'react';
import insuranceDetailsService from '../insuranceDetails/insuranceDetailsService';
import './insurancePage.css';

const insuranceService = new insuranceDetailsService();

const InsurancePage = () => {
  const [insuranceList, setInsuranceList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const itemsPerPage = 9;

  useEffect(() => {
    const fetchInsurance = async () => {
      try {
        const data = await insuranceService.getAllInsuranceDetails();
        const withImageUrls = data.map(item => {
          const imageUrl = item.imageName ? `/images/insurance/${item.imageName}` : '/images/insurance/default.jpg';
          return { ...item, imageUrl };
        });
        setInsuranceList(withImageUrls);
      } catch (err) {
        console.error('Error loading insurance:', err);
        setInsuranceList(null);
      }
    };

    fetchInsurance();
  }, []);

  const filteredList = insuranceList.filter(item =>
    item.insName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  const handlePageChange = (direction) => {
    if (direction === 'prev' && currentPage > 1) setCurrentPage(currentPage - 1);
    else if (direction === 'next' && currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <div id="app" style={{ margin: 0 }}>
      <input
        type="text"
        placeholder="Search insurance by name"
        className="insurance-search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {insuranceList === null ? (
        <p>Failed to load insurance details.</p>
      ) : (
        <div className="insurance-grid">
          {currentItems.map((item) => (
            <div
              key={item.ins_id}
              className="insurance-card"
              onClick={() => setSelectedItem(item)}
            >
              <img
                src={item.imageUrl}
                alt={item.insName}
                className="insurance-thumbnail"
                onError={(e) => { e.target.onerror = null; e.target.src = '/images/insurance/default.jpg'; }}
              />
              <strong>{item.insName}</strong>
              <br />
              {item.coverageName}
              <p className="view-more">Click for more</p>
            </div>
          ))}
        </div>
      )}

      {totalPages > 1 && (
        <div className="pagination">
          <button onClick={() => handlePageChange('prev')} disabled={currentPage === 1}>Prev</button>
          <span>Page {currentPage} of {totalPages}</span>
          <button onClick={() => handlePageChange('next')} disabled={currentPage === totalPages}>Next</button>
        </div>
      )}

      {selectedItem && (
        <>
          <div className="overlay" onClick={() => setSelectedItem(null)} />
          <div className="popup animate-popup">
            <span className="popup-close" onClick={() => setSelectedItem(null)}>&times;</span>
            <img
              src={selectedItem.imageUrl}
              alt={selectedItem.insName}
              className="popup-image"
              onError={(e) => { e.target.onerror = null; e.target.src = '/images/insurance/default.jpg'; }}
            />
            <h3>{selectedItem.insName}</h3>
            <p><strong>Authorization:</strong> {selectedItem.authorization}</p>
            <p><strong>Coverage:</strong> {selectedItem.coverageName}</p>
            <p><strong>Acceptance:</strong> {selectedItem.acceptance}</p>
          </div>
        </>
      )}
    </div>
  );
};

export default InsurancePage;
